import { render } from "./ContactBox.vue?vue&type=template&id=20fe8b2d&scoped=true"
const script = {}

import "./ContactBox.vue?vue&type=style&index=0&id=20fe8b2d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20fe8b2d"]])

export default __exports__